/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getUsers = /* GraphQL */ `
  query GetUsers($user_id: String!) {
    getUsers(user_id: $user_id) {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const listUserss = /* GraphQL */ `
  query ListUserss {
    listUserss {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const getCustomerData = /* GraphQL */ `
  query GetCustomerData($customer_id: String!) {
    getCustomerData(customer_id: $customer_id) {
      customer_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const listCustomerDatas = /* GraphQL */ `
  query ListCustomerDatas {
    listCustomerDatas {
      customer_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const getCustomer = /* GraphQL */ `
  query GetCustomer($customer_id: String!) {
    getCustomer(customer_id: $customer_id) {
      client_id
      user_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      customer_id
      __typename
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers {
    listCustomers {
      client_id
      user_id
      name
      description
      account_email
      billing_email
      billing_details
      shipping_details
      time_zone
      invoice_prefix
      next_invoice
      tax_id
      inserted_dt
      updated_dt
      customer_id
      __typename
    }
  }
`;
export const getUSER = /* GraphQL */ `
  query GetUSER($user_id: String!) {
    getUSER(user_id: $user_id) {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const listUSERs = /* GraphQL */ `
  query ListUSERs {
    listUSERs {
      client_id
      user_id
      first_name
      last_name
      email
      company_name
      country
      is_active
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const getUser_profile = /* GraphQL */ `
  query GetUser_profile($user_profile_id: String!) {
    getUser_profile(user_profile_id: $user_profile_id) {
      user_profile_id
      client_id
      user_id
      billing_plan
      client_company_ein
      client_comapny_segement
      address
      acct_display_name
      is_admin
      __typename
    }
  }
`;
export const listUser_profiles = /* GraphQL */ `
  query ListUser_profiles {
    listUser_profiles {
      user_profile_id
      client_id
      user_id
      billing_plan
      client_company_ein
      client_comapny_segement
      address
      acct_display_name
      is_admin
      __typename
    }
  }
`;
export const getCoupon = /* GraphQL */ `
  query GetCoupon($coupon_id: String!) {
    getCoupon(coupon_id: $coupon_id) {
      coupon_id
      client_id
      user_id
      name
      coupon_type
      percentage_off
      specific_product
      duration
      redemption_limits
      codes
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const listCoupons = /* GraphQL */ `
  query ListCoupons {
    listCoupons {
      coupon_id
      client_id
      user_id
      name
      coupon_type
      percentage_off
      specific_product
      duration
      redemption_limits
      codes
      inserted_dt
      updated_dt
      __typename
    }
  }
`;
export const getInvoice_Items = /* GraphQL */ `
  query GetInvoice_Items($invoice_items_id: String!) {
    getInvoice_Items(invoice_items_id: $invoice_items_id) {
      client_id
      user_id
      invoice_items_id
      item
      qty
      price
      supply_date
      inserted_dt
      updated_dt
      customer_id
      status
      __typename
    }
  }
`;
export const listInvoice_Itemss = /* GraphQL */ `
  query ListInvoice_Itemss {
    listInvoice_Itemss {
      client_id
      user_id
      invoice_items_id
      item
      qty
      price
      supply_date
      inserted_dt
      updated_dt
      customer_id
      status
      __typename
    }
  }
`;
export const getProduct_info = /* GraphQL */ `
  query GetProduct_info($product_id: String!) {
    getProduct_info(product_id: $product_id) {
      product_id
      customer_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const listProduct_infos = /* GraphQL */ `
  query ListProduct_infos {
    listProduct_infos {
      product_id
      customer_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const getProductInfo = /* GraphQL */ `
  query GetProductInfo($product_id: String!) {
    getProductInfo(product_id: $product_id) {
      product_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const listProductInfos = /* GraphQL */ `
  query ListProductInfos {
    listProductInfos {
      product_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      metadata
      feature_list
      __typename
    }
  }
`;
export const getPrice_info = /* GraphQL */ `
  query GetPrice_info($price_id: String!) {
    getPrice_info(price_id: $price_id) {
      price_id
      customer_id
      client_id
      user_id
      pricing_model
      price_data
      units_data
      select_currency
      billing_type
      metadata
      billing_period
      charge_metered
      price_description
      free_trial
      product_id
      __typename
    }
  }
`;
export const listPrice_infos = /* GraphQL */ `
  query ListPrice_infos {
    listPrice_infos {
      price_id
      customer_id
      client_id
      user_id
      pricing_model
      price_data
      units_data
      select_currency
      billing_type
      metadata
      billing_period
      charge_metered
      price_description
      free_trial
      product_id
      __typename
    }
  }
`;
export const getProductstatus = /* GraphQL */ `
  query GetProductstatus($production_id: String!) {
    getProductstatus(production_id: $production_id) {
      production_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      meta_data
      feature_list
      __typename
    }
  }
`;
export const listProductstatuss = /* GraphQL */ `
  query ListProductstatuss {
    listProductstatuss {
      production_id
      client_id
      user_id
      name
      description
      statement_descriptor
      unit_label
      meta_data
      feature_list
      __typename
    }
  }
`;
export const getUSER_EXTENSION = /* GraphQL */ `
  query GetUSER_EXTENSION($activate_payment_id: String!) {
    getUSER_EXTENSION(activate_payment_id: $activate_payment_id) {
      client_id
      user_id
      email
      activate_payment_id
      business_location
      type_of_business
      business_structure
      business_name
      business_indentification_number
      doing_business_as
      business_country
      business_address1
      business_address2
      business_city
      business_state
      zip
      business_phone_number
      industry
      business_website
      product_description
      representative_first_name
      representative_last_name
      representative_email
      representative_job_title
      representative_DOB
      representative_country
      representative_address1
      representative_address2
      representative_city
      representative_state
      representative_zip
      representative_phone_number
      representative_social_sequrity_number
      owner_first_name
      owner_last_name
      owner_email
      is_physical_goods
      recive_goods_services
      statement_descriptor
      shortened_descriptor
      customer_suport_phone
      customer_suport_country
      customer_suport_address1
      customer_suport_address2
      customer_suport_city
      customer_suport_state
      customer_suport_zip
      routing_number
      account_number
      confirm_account_number
      account_secure_method
      your_product_category
      __typename
    }
  }
`;
export const listUSER_EXTENSIONs = /* GraphQL */ `
  query ListUSER_EXTENSIONs {
    listUSER_EXTENSIONs {
      client_id
      user_id
      email
      activate_payment_id
      business_location
      type_of_business
      business_structure
      business_name
      business_indentification_number
      doing_business_as
      business_country
      business_address1
      business_address2
      business_city
      business_state
      zip
      business_phone_number
      industry
      business_website
      product_description
      representative_first_name
      representative_last_name
      representative_email
      representative_job_title
      representative_DOB
      representative_country
      representative_address1
      representative_address2
      representative_city
      representative_state
      representative_zip
      representative_phone_number
      representative_social_sequrity_number
      owner_first_name
      owner_last_name
      owner_email
      is_physical_goods
      recive_goods_services
      statement_descriptor
      shortened_descriptor
      customer_suport_phone
      customer_suport_country
      customer_suport_address1
      customer_suport_address2
      customer_suport_city
      customer_suport_state
      customer_suport_zip
      routing_number
      account_number
      confirm_account_number
      account_secure_method
      your_product_category
      __typename
    }
  }
`;
export const getUserinfo = /* GraphQL */ `
  query GetUserinfo($id: ID!) {
    getUserinfo(id: $id) {
      id
      fullname
      email
      phonenumber
      country_name
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listUserinfos = /* GraphQL */ `
  query ListUserinfos(
    $id: ID
    $filter: ModelUserinfoFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUserinfos(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        fullname
        email
        phonenumber
        country_name
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getContact = /* GraphQL */ `
  query GetContact($id: ID!) {
    getContact(id: $id) {
      id
      name
      email
      description
      billinginfo {
        id
        time_zone
        language_name
        currency_name
        invoice_prefix
        next_invoice_sequence
        tax_status
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
  }
`;
export const listContacts = /* GraphQL */ `
  query ListContacts(
    $id: ID
    $filter: ModelContactFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listContacts(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        name
        email
        description
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
